/* eslint no-console:0 */

import jQuery from 'jquery'
import jqueryUjsInit from 'jquery-ujs'

import 'core-js/stable'
import 'intersection-observer'
import 'regenerator-runtime/runtime'
// IE11 compatibility
import 'custom-event-polyfill'
import '@ungap/global-this'
import 'loading-attribute-polyfill'

import './config/universal'
import './event_bus'
import './consent_listener'

import './adblock_fence'
import './bookmarks'
import './email_change'
import './google_maps'
import './ivw_tracking'
import './job_ad'
import './layout'
import './password'
import './popstate_fix'
import './registration_teaser'
import './registration_fence'
import './scroll_to_top'
import './search/bind'
import './search/toggle'
import './search_profiles'
import './social_feed'
import './snackbar'
import './toggle'
import './webtrekk_tracking'
import './gtm_tracking'
import './widgets'
import './youtube_video'

global.$ = global.jQuery = jQuery
jqueryUjsInit(jQuery)
